// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  LOADING_HIDE,
  LOADING_SHOW,
} from './types'

export const loadingHide = () => ({
  type: LOADING_HIDE,
})

export const loadingShow = () => ({
  type: LOADING_SHOW,
})
